import { useMemo } from 'react';

import { usePenOverviewController_getPenOverview } from '@/services/hooks';

import { mapPenOverviewToDomain } from './mappers';
import type { PenOverview, UseGetPenOverviewResult } from './types';

const EMPTY_PEN_OVERVIEW: PenOverview = {
    locationId: 0,
    locationName: '',
    timezone: '',
    pens: [],
    allPens: [],
};

export const useGetPenOverview = (locationId: number): UseGetPenOverviewResult => {
    const query = usePenOverviewController_getPenOverview(locationId, {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        refetchInterval: 60_000,
    });

    const data = useMemo(
        () => (query.data?.data ? mapPenOverviewToDomain(query.data.data) : EMPTY_PEN_OVERVIEW),
        [query.data?.data]
    );

    return { ...query, isLoading: query.isPending, data };
};
